<template>
  <div id="app"  :class="mobileClass" >



    <Desktop v-if="!isMobile"  :isMobile="isMobile" :lang="lang" :route="$route"></Desktop>
    <Mobile v-if="isMobile"  :isMobile="isMobile" :lang="lang" :route="$route"> </Mobile>

    <cookies :isMobile="isMobile" :lang="lang" ></cookies>




    <!--div v-if="isMobile && clicked" style="width: 100vw; height: 100vh; position: fixed; top: 0; left: 0; background: red;"  v-on:click="openFullscreen"></div-->

  </div>
</template>

<script>




import Desktop from './components/Desktop'


import {PATH, EVENTBUS} from './main';
import Mobile from "./components/Mobile";
import Icons from "./components/Modules/Icons";
import Cookies from "./components/Modules/Cookies";

export default {
  name: 'App',
  components: {
    Cookies,
    Icons,
    Mobile,

    Desktop,
  },
  watch: {
    '$route' (to, from) {
      //console.log('to: ' + to.path);
      //console.log('from: ' + from.path);

      $("body, html").removeAttr('class');
      $("body, html").attr('class', '');
      $('body, html').addClass(this.$route.name + '-body')


    }
  },
  data() {
    return {
      route: {},

      isMobile: false,

      mobileClass: '',
      lang: 0,
      clicked: false

    }
  },

  created() {
    //console.log(this.$route);
    if(this.$route.name == '404'){
      this.$router.push('/');
    }


    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('lang');


    if(myParam == 'en'){
      this.lang  = 1;
    }


    this.resizeApp();

  },
  mounted() {
    const _this = this;

    //EVENTBUS.$on('AAA', AAA);
    //EVENTBUS.$emit('AAA', 0);
    //console.log(this.labels)

    $('body, html').addClass(this.$route.name + '-body')

    if(this.$route.name === 'home'){
    //  $('body, html').css('overflow', 'hidden');
    }











    EVENTBUS.$on('changLang', this.changLang);


    window.addEventListener('resize', this.resizeApp);
    this.resizeApp();

    this.dataLoaded = true;

},

  methods: {


    changLang(n){

      this.lang = n

    },

    openFullscreen() {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }

      this.clicked = true;
    },


    chceckMobile(){

      var bol = false;

      var isMobileJS = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },





      };

      if (isMobileJS.Android() || isMobileJS.BlackBerry() || isMobileJS.iOS() || isMobileJS.Opera() || isMobileJS.Windows()) {
        bol = true;
      }

      return bol;
    },




    resizeApp(){


      let vh = window.innerHeight * 0.01;

     document.documentElement.style.setProperty('--vh', `${vh}px`);



      if(this.isMobile && this.chceckMobile() && window.innerWidth > 800){

      }else{
        if(window.innerWidth > 800) {
          this.isMobile =  false;
          this.mobileClass =  'desktop';
        }else{
          this.isMobile =  true;
          this.mobileClass =  'mobile';


        }
      }


    }




  }
}
</script>






// WEBPACK FOOTER //
// src/App.vue